// extracted by mini-css-extract-plugin
module.exports = {"vr":"Vr_vr__1S4Q2"};